import { z } from "zod";
import { US_STATES } from "constants/usStates";
import { DISQUALIFIED_STATES } from "constants/disqualifiedStates";

// State Schema
export const stateSchema = z
    .string()
    .min(1, { message: "Please select your state" })
    .regex(/^[A-Z]{2}$/, { message: "Please select your state" });

export const optionalStateSchema = z.string().optional();

// A GIWL-eligible US state: a real state code that is not GIWL-disqualified (NY).
export const giwlStateSchema = z
    .enum(US_STATES, { errorMap: () => ({ message: "Please select your state" }) })
    .refine((state) => !DISQUALIFIED_STATES.giwl.includes(state), {
        message: "New York is not supported",
    });
